import { dispatch } from '../store/state';
import { CompanyList } from '../apis/Brand/Company/CompanyList';
import { message } from 'antd';

export const GetCompanyList = (val, def, token, company) => {
  CompanyList(token).then(({ response, status }) => {
    function findId (companies) {
      return companies.id === val;
    }
    if (status === 200) {
      dispatch({
        type: 'SET_COMPANY',
        payload: {
          ...company,
          all: response,
          selected: def ?
            company.selected || response[0] :
            response.find(findId),
          // credit:{}
        },
      });
    } else {
      message.error('Error while getting company');
    }
  });
};
